exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-cc61e0f2]{width:120px;height:120px;-o-object-fit:contain;object-fit:contain}.imageStyle[data-v-cc61e0f2]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:630px}", ""]);

// exports
